import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-site-search-no-result',
    templateUrl: './site-search-no-result.component.html',
    styleUrls: ['./site-search-no-result.component.scss'],
    standalone: false
})
export class SiteSearchNoResultComponent implements OnInit {
  @Input() byLocation: boolean;
  @Output() retry = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  onRetryClick(byLocation: boolean) {
    this.retry.emit(byLocation);
  }
}
